const _usdFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
})

/**
 * Get currency format to a number
 *
 * @param {number} amount
 */
export const currencyFormat = (amount) => {
	if (amount == null) return ''
	return _usdFormatter.format(amount)
}
